import React, { useContext, useEffect, useState } from "react";
import { TextField, MenuItem, Button } from "@mui/material";
import { ContextData } from "../../../../../../context/Context";
import axios from "axios";
import { toast } from "react-toastify";
import baseUrl from "../../../../../../BaseURL";
import SoundAlert from "../../../../../../routes/SoundAlert";
import { Putrequest } from "../../../../../../context/AxiosRequest";

function Sponsor({ formData }) {

  const { UserTokens, ReloadBioForms, setReloadBioForms } = useContext(ContextData);

  const [formDatas, setFormDatas] = useState({
    first_name: "",
    middle_name:  "",
    surname: "",
    date_of_birth:  "",
    gender: "",
    marital_status:  "",
    phone_no_1:  "",
    phone_no_2:  "",
    email:  "",
    number_of_dependants:  "",
    mother_maiden_name:  "",
    bvn:  "",
    nin_number:  "",
    tin_number: "",
    billing_address:  "",

  });

  const handleChange = (e) => {

    const { name, value } = e.target;
    setFormDatas((prevData) => ({ ...prevData, [name]: value }));


  };

  const validateField = (type, value) => {
    // Optional fields
     // console.log(type, value)


    if (type === "gender" || type === "marital_status") return true;

    // Email validation
    if (type === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value.trim());
    }

    // Numeric-only fields with max 15 digits
    const numericFields = [

      "phone_no_1",
      "phone_no_2",
      "number_of_dependants",
      "bvn",
      "nin_number",
      "tin_number",
      
    ];
    if (numericFields.includes(type)) {
      return /^\d{1,15}$/.test(value.trim());
    }

    // Default: must not be empty
    return value.trim() !== "";
  };

  const handleSubmit = async (type) => {

    if (!validateField(type, formDatas[type])) {

      SoundAlert("error");

      if (type === "email") {

        toast.error("Please enter a valid email address.");

      } else if (
        ["phone_no_1", "phone_no_2", "number_of_dependants", "bvn", "nin_number", "tin_number"].includes(type)
      ) {
        toast.error("Must be numbers only (max 15 digits).");
      } else {
         SoundAlert("error");
        toast.error("Please fill in this field.");
      }
      return;
    }

    
       
        const response = await Putrequest("auth/update_sponsor_identification",{...formDatas,user_token:UserTokens})
   
               
                   if(response.status){

                    SoundAlert("success")
                    toast.success(response.textStatus)
                    setReloadBioForms(!ReloadBioForms)

                      }


      
  };



  useEffect(()=>{
  
         setFormDatas({
    first_name: formData.sponsorIdentification.first_name || "" ,
    middle_name: formData.sponsorIdentification.middle_name || "" ,
    surname: formData.sponsorIdentification.surname || "" ,
    date_of_birth: formData.sponsorIdentification.date_of_birth || "" ,
    gender: formData.sponsorIdentification.gender || "",
    marital_status: formData.sponsorIdentification.marital_status || "" ,
    phone_no_1: formData.sponsorIdentification.phone_no_1 || "",
    phone_no_2: formData.sponsorIdentification.phone_no_2 || "" ,
    email: formData.sponsorIdentification.email || "",
    number_of_dependants: formData.sponsorIdentification.number_of_dependants || "",
    mother_maiden_name: formData.sponsorIdentification.mother_maiden_name || "" ,
    bvn: formData.sponsorIdentification.bvn || "",
    nin_number: formData.sponsorIdentification.nin_number || "" ,
    tin_number: formData.sponsorIdentification.tin_number || "",
    billing_address: formData.sponsorIdentification.billing_address || "" ,
         })
  
  },[formData])
  





  return (
    <div className="pt-2 pb-2">
      {/* First Name */}
     
      <TextField
        label="First Name"
        name="first_name"
        value={formDatas.first_name}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("first_name")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Middle Name */}
      <TextField
        label="Middle Name"
        name="middle_name"
        value={formDatas.middle_name}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("middle_name")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Surname */}
      <TextField
        label="Surname"
        name="surname"
        value={formDatas.surname}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("surname")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Date of Birth */}
      <p className="pt-1 pb-1 font-extrabold">Date of Birth : <span>{formDatas?.date_of_birth}</span></p>
      <TextField
        name="date_of_birth"
        type="date"
        value={formDatas.date_of_birth}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("date_of_birth")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Gender */}
      <TextField
        select
        label="Gender "
        name="gender"
        value={formDatas.gender}
        onChange={handleChange}
        fullWidth
        margin="dense"
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("gender")}>
              Save
            </Button>
          ),
        }}
      >
        <MenuItem value="Male">Male</MenuItem>
        <MenuItem value="Female">Female</MenuItem>
      </TextField>

      {/* Phone No 1 */}
      <TextField
        label="Phone No. 1"
        name="phone_no_1"
        value={formDatas.phone_no_1}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        inputProps={{ maxLength:  11, inputMode: "numeric",}}
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("phone_no_1")}>
              Save
            </Button>
          )
          
        }}
      />

      {/* Phone No 2 */}
      <TextField
        label="Phone No. 2"
        name="phone_no_2"
        value={formDatas.phone_no_2}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        inputProps={{ maxLength:  11, inputMode: "numeric"}}
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("phone_no_2")}>
              Save
            </Button>
          )
        }}
      />

      {/* Marital Status */}
      <TextField
        select
        label="Marital Status"
        name="marital_status"
        value={formDatas.marital_status}
        onChange={handleChange}
        fullWidth
        margin="dense"
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("marital_status")}>
              Save
            </Button>
          ),
        }}
      >
        <MenuItem value="Single">Single</MenuItem>
        <MenuItem value="Married">Married</MenuItem>
        <MenuItem value="Divorced">Divorced</MenuItem>
        <MenuItem value="Widowed">Widowed</MenuItem>
      </TextField>

      {/* Email */}
      <TextField
        label="Email"
        name="email"
        value={formDatas.email}
        onChange={handleChange}
        type="email"
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("email")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Number of Dependants */}
      <TextField
        label="Number of Dependants"
        name="number_of_dependants"
        value={formDatas.number_of_dependants}
        onChange={handleChange}
        type="number"
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => handleSubmit("number_of_dependants")}
            >
              Save
            </Button>
          ),
        }}
      />

      {/* Mother's Maiden Name */}
      <TextField
        label="Mother's Maiden Name"
        name="mother_maiden_name"
        value={formDatas.mother_maiden_name}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => handleSubmit("mother_maiden_name")}
            >
              Save
            </Button>
          ),
        }}
      />

      {/* BVN */}
      <TextField
        label="BVN"
        name="bvn"
        value={formDatas.bvn}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        inputProps={{ maxLength:  11, inputMode: "numeric"}}
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("bvn")}>
              Save
            </Button>
          ),
         
        }}
      />

      {/* NIN */}
      <TextField
        label="NIN Number"
        name="nin_number"
        value={formDatas.nin_number}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        inputProps={{ maxLength:  11, inputMode: "numeric"}}
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("nin_number")}>
              Save
            </Button>
          )
        }}
      />

      {/* TIN */}
      <TextField
        label="TIN Number Optional"
        name="tin_number"
        value={formDatas.tin_number}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("tin_number")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Billing Address */}
      <TextField
        label="Billing Address"
        name="billing_address"
        value={formDatas.billing_address}
        onChange={handleChange}
        fullWidth
        margin="dense"
        multiline
        rows={3}
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("billing_address")}>
              Save
            </Button>
          ),
        }}
      />
    </div>
  );
}

export default Sponsor;
